import { render, staticRenderFns } from "./BscProProdef.vue?vue&type=template&id=1d98c163"
import script from "./BscProProdef.vue?vue&type=script&lang=js"
export * from "./BscProProdef.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports